export default __webpack_public_path__ + "static/media/nav.0fcb62c3.jpg";